export enum WS_EVENTS {
  MESSAGE_RECEIVED = "ws:message_received",
  CHAT_TITLE_UPDATE = "chat:title-update",
  CHAT_NOTIFICATION = 'chat:notification',
  CHAT_CLOSED = 'chat:closed',
  CHANNEL_ADD = 'channels:add',
  CONFIG_FLAGS_UPDATE = 'ws:config_flags',
  RELEASE_NOTE_PUBLISHED = 'ws:release_note_published',
  TICKET_CHANGED = 'ws:ticket_changed'
}

export enum APP_EVENTS {
  SET_SIDEBAR_TAB = "sidebar:tab-update"
}